import React, { useState } from "react";
import { useStaticQuery, graphql } from "gatsby";

import { normalizeTwoWords, formatImageAlt, findRel } from "../../../shared/utils/stringUtilities";
import NavMenu from "../../molecules/nav-menu/navMenu";
import RecommenderModal from "../recommender-modal/recommenderModal";

import "./nav.scss";

interface NavInterface {
  isMenuActive: boolean;
  isSearcherActive: boolean;
  isDark: boolean;
  actionTheme: () => void;
}

const Nav = ({
  isMenuActive,
  isSearcherActive,
  isDark,
  actionTheme,
}: NavInterface) => {
  const data = useStaticQuery(graphql`
    query MENU_SIDE_OPTIONS {
      allContentfulMenuCategorias(
        filter: { titulo: { eq: "Menu bibliotecas" } }
      ) {
        nodes {
          iconosLaterales {
            slug
            hyperLink
            nombreCategoria
            imagenDestacada {
              description
              file {
                url
              }
            }
          }
        }
      }
    }
  `);

  const { iconosLaterales } = data.allContentfulMenuCategorias.nodes[0];
  const [isRecommenderOpen, setIsRecommenderOpen] = useState(false);

  return (
    <div className="o-nav">
      <section className="o-nav__bar">
        <ul className="o-nav__bar-links hide-on-mobile">
          {iconosLaterales &&
            iconosLaterales.map((item, i) => (
              <li key={`link${i}`}>
                {item.imagenDestacada[0].description ===
                "recomendador de libros" ? (
                  <div
                    className={`gtmMenuTrans${normalizeTwoWords(
                      item.nombreCategoria
                    )}`}
                    onClick={() => setIsRecommenderOpen(true)}
                  >
                    <img
                      className={`gtmMenuTrans${normalizeTwoWords(
                        item.nombreCategoria
                      )}`}
                      src={item.imagenDestacada[0].file.url}
                      alt={
                        formatImageAlt(item.imagenDestacada[0].title) ||
                        "Imagen lateral nav"
                      }
                    />
                  </div>
                ) : (
                  <a
                    className={`gtmMenuTrans${normalizeTwoWords(
                      item.nombreCategoria
                    )}`}
                    href={item.hyperLink ? item.hyperLink : item.slug}
                    target={item.hyperLink && item.nombreCategoria !== "Mis préstamos" ? "_blank" : "_self"}
                    rel={findRel(item.hyperLink)}
                  >
                    <img
                      className={`gtmMenuTrans${normalizeTwoWords(
                        item.nombreCategoria
                      )}`}
                      src={item.imagenDestacada[0].file.url}
                      alt={
                        formatImageAlt(item.imagenDestacada[0].title) ||
                        "Imagen lateral nav"
                      }
                    />
                  </a>
                )}
                <span className="o-nav__bar-tooltip">
                  {" "}
                  {item.nombreCategoria}{" "}
                </span>
              </li>
            ))}
        </ul>
      </section>

      <RecommenderModal
        open={isRecommenderOpen}
        onClose={() => setIsRecommenderOpen(false)}
      />

      <NavMenu
        isMenuActive={isMenuActive}
        isSearcherActive={isSearcherActive}
        sideLinks={iconosLaterales}
        isDark={isDark}
        actionTheme={actionTheme}
      />
    </div>
  );
};

export default Nav;
